import React from 'react'
import { I18n, hooks } from '@front/volcanion'

import { Badge, Grid, Typography } from '@mui/material'

import List from './List'
import Driver from './Driver'

const MultipleDispatch = (props) => {
  const [order_ids] = hooks.useFormState('order_ids')
  return (
    <Grid container columnSpacing={4} rowSpacing={2}>
      <Grid size={12}>
        <Badge badgeContent={order_ids?.length} color="primary" sx={{ m: 0 }}>
          <Typography variant='h5' color='primary' textTransform='uppercase'>
            {I18n.t('dispatch.group.title')}
          </Typography>
        </Badge>
      </Grid>
      <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }} size={12}>
        <Typography fontSize={16} color='primary' fontWeight={600}>
          {I18n.t('dispatch.group.text')}
        </Typography>
      </Grid>
      <Grid sx={{ maxHeight: 780, overflowY: 'scroll' }} size={8}>
        <List />
      </Grid>
      <Grid size={4}>
        <Driver />
      </Grid>
    </Grid>
  );
}

export default React.memo(MultipleDispatch) 
